import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const DEPOSITSUMMARY_LOAD = 'DEPOSITSUMMARY/DEPOSITSUMMARY_LOAD';
export const DEPOSITSUMMARY_SUCCESS = 'DEPOSITSUMMARY/DEPOSITSUMMARY_SUCCESS';
export const DEPOSITSUMMARY_FAILURE = 'DEPOSITSUMMARY/DEPOSITSUMMARY_FAILURE';

export const fetchUrl = `${config.achApiUrl}`;

export function getDepositSummary(filters, page, pageSize, sorters, merchantIds) {
    const queryParamsString = createQueryParams({
        dateKey: 'date',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getDepositSummaryFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: DEPOSITSUMMARY_LOAD,
        successActionTypeOrCreator: getDepositSummarySuccessActionCreator
    };
}

export function getDepositSummarySuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, DEPOSITSUMMARY_SUCCESS, 'depositSummary');
}

export function getDepositSummaryFailureActionCreator(error) {
    return {
        error,
        type: DEPOSITSUMMARY_FAILURE
    };
}
